<div class="agent-chat-container" [class.open]="isOpen$ | async">

  <!-- Chat Window -->
  <div class="chat-window shadow" *ngIf="isOpen$ | async">
    <div class="chat-header d-flex justify-content-between align-items-center">
      <div class="d-flex align-items-center">
        <span class="mr-2">🤖</span>
        <h6 class="m-0">AI Agent</h6>
      </div>
      <button class="btn btn-sm btn-link text-white close-btn" (click)="toggleChat()">
        <i class="fa fa-times"></i>
      </button>
    </div>

    <div class="chat-messages" #scrollContainer>
      <div class="message-wrapper" *ngFor="let msg of messages$ | async"
        [ngClass]="{'user': msg.role === 'user', 'assistant': msg.role === 'assistant', 'system': msg.role === 'system'}">
        <div class="message-bubble shadow-sm" (click)="msg.role === 'assistant' ? onMessageClick($event) : null">
          <ng-container *ngIf="msg.role === 'assistant'; else textContent">
            <markdown [data]="msg.content"></markdown>
          </ng-container>
          <ng-template #textContent>
            {{ msg.content }}
          </ng-template>

          <!-- Widgets -->
          <div class="widgets-container mt-3" *ngIf="msg.widgets?.length">
            <ng-container *ngFor="let widget of msg.widgets" [ngSwitch]="widget.type">

              <!-- Card Widget -->
              <div *ngSwitchCase="'card'" class="widget-card mb-2 p-3 border rounded bg-light">
                <div class="d-flex justify-content-between align-items-start mb-1">
                  <h6 class="m-0 font-weight-bold text-dark" *ngIf="widget.title">{{ widget.title }}</h6>
                  <span *ngIf="widget.status"
                    class="badge badge-{{widget.status === 'critical' ? 'danger' : widget.status}}">{{ widget.status
                    }}</span>
                </div>
                <div *ngIf="widget.subtitle" class="small text-muted mb-2">{{ widget.subtitle }}</div>
                <div *ngIf="widget.description" class="small text-dark mb-2"
                  [innerHTML]="widget.description | safeHtml"></div>

                <div *ngIf="widget.actions?.length" class="mt-2 d-flex flex-wrap">
                  <button *ngFor="let act of widget.actions" class="btn btn-sm btn-outline-primary mr-1 mb-1 bg-white"
                    (click)="handleAction(act)">
                    {{ act.label }}
                  </button>
                </div>
              </div>

              <!-- Button Group Widget -->
              <div *ngSwitchCase="'button_group'" class="widget-btn-group mt-1">
                <button *ngFor="let item of widget.items" class="btn btn-sm btn-outline-info mr-1 mb-1 rounded-pill"
                  (click)="handleAction(item.action)">
                  {{ item.label }}
                </button>
              </div>

              <!-- List Widget -->
              <div *ngSwitchCase="'list'" class="widget-list border rounded bg-white overflow-hidden mb-2">
                <div class="px-3 py-2 bg-light border-bottom" *ngIf="widget.title">
                  <small class="font-weight-bold text-uppercase text-muted">{{ widget.title }}</small>
                </div>
                <div class="list-group list-group-flush">
                  <div *ngFor="let item of widget.items"
                    class="list-group-item p-2 d-flex align-items-center action-item"
                    (click)="item.action ? handleAction(item.action) : null" [class.cursor-pointer]="item.action">
                    <i *ngIf="item.action" class="fa fa-chevron-left text-muted small mr-2"></i>
                    <div class="d-flex flex-column" style="min-width: 0;">
                      <span class="text-truncate" style="max-width: 100%;">{{ item.text }}</span>
                      <small class="text-muted text-truncate" *ngIf="item.subText">{{ item.subText }}</small>
                    </div>
                  </div>
                </div>
              </div>

            </ng-container>
          </div>
        </div>
        <div class="message-time text-muted small mt-1">
          {{ msg.timestamp | date:'HH:mm' }}
        </div>
      </div>

      <div class="message-wrapper assistant" *ngIf="isLoading$ | async">
        <div class="message-bubble loading-bubble">
          <div class="typing-indicator">
            <span></span><span></span><span></span>
          </div>
        </div>
      </div>
    </div>

    <div class="chat-input-area p-2 border-top">
      <div class="input-group">
        <textarea class="form-control" placeholder="무엇을 도와드릴까요?" [(ngModel)]="userInput" (keydown)="onKeydown($event)"
          rows="1" style="resize: none;"></textarea>
        <div class="input-group-append">
          <button class="btn btn-primary" type="button" (click)="sendMessage()"
            [disabled]="!userInput.trim() || (isLoading$ | async)">
            <i class="fa fa-paper-plane"></i>
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Toggle Button (FAB) -->
  <button class="chat-fab shadow btn btn-primary rounded-circle" (click)="toggleChat()" *ngIf="!(isOpen$ | async)">
    <i class="fa fa-comments fa-lg"></i>
  </button>

</div>